import React, { useState, useEffect, useCallback } from 'react';
import '../assets/css/Hero.css';


const SERVICES = [
  'Steel Fabrication',
  'Construction Management',
  'Structural Engineering',
  'Building Renovation',
  'Project Planning',
  'Quality Assurance'
];

const STATS = [
  { value: '35+', label: 'Years Experience' },
  { value: '250+', label: 'Projects Completed' },
  { value: '98%', label: 'Client Satisfaction' },
  { value: '24/7', label: 'Support Available' }
];

const CAROUSEL_SLIDES = [
  { id: 'slide1', className: 'carousel-slide slide1' },
  { id: 'slide2', className: 'carousel-slide slide2' },
  { id: 'slide3', className: 'carousel-slide slide3' }
];

const useServiceRotation = () => {
  const [currentService, setCurrentService] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentService((prev) => (prev + 1) % SERVICES.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return currentService;
};

const useFadeIn = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return isVisible;
};

const HeroBackground = () => (
  <div className="hero-background">
    {CAROUSEL_SLIDES.map((slide) => (
      <div key={slide.id} className={slide.className} />
    ))}
    <div className="gradient-overlay" />
  </div>
);

const HeroTitle = () => (
  <h1 className="hero-title">
    Building Excellence<br />
    <span className="gradient-text">Since 1988</span>
  </h1>
);

const ServiceTagline = ({ currentService }) => (
  <p className="hero-tagline">
    We turn visions into{' '}
    <span className="rotating-service">{SERVICES[currentService]}</span>
  </p>
);

const HeroDescription = () => (
  <p className="hero-description">
    MECONSTEEL88 CO. delivers premium construction and steel fabrication services
    with commitment to quality, safety, and timely delivery.
  </p>
);

const CTAButtons = ({ scrollToSection }) => (
  <div className="hero-actions">
    <button 
      className="cta-button primary" 
      onClick={() => scrollToSection('contact')}
    >
      Get Free Quote →
    </button>
    <button 
      className="cta-button secondary" 
      onClick={() => scrollToSection('services')}
    >
      Our Services
    </button>
  </div>
);

const StatsGrid = () => (
  <div className="hero-stats">
    {STATS.map((stat, index) => (
      <div key={`stat-${index}`} className="stat-item">
        <div className="stat-value">{stat.value}</div>
        <div className="stat-label">{stat.label}</div>
      </div>
    ))}
  </div>
);


function Hero() {
  const currentService = useServiceRotation();
  const isVisible = useFadeIn();
  
  const scrollToSection = useCallback((id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }, []);

  return (
    <section id="home" className="hero">
      <HeroBackground />
      
      <div className="container hero-container">
        <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
          <HeroTitle />
          <ServiceTagline currentService={currentService} />
          <HeroDescription />
          <CTAButtons scrollToSection={scrollToSection} />
          <StatsGrid />
        </div>
      </div>
    </section>
  );
}

export default Hero;